import "../styles.scss";

import { API, Endpoints } from "utils/api";
import { Col, Input, Modal, Popconfirm, Row, notification } from "antd";
import { setAcceptedChat, setBreadcrumb, setFinishedChat, setLoader, setPendingMessages } from "store/actions";

import Animation from "assets/images/lottie/chat.json";
import { DateTime } from "luxon";
import DoctorPlaceholder from "assets/images/placeholders/doctor.jpg";
import { Footer } from "screens";
import { Helmet } from "react-helmet";
import { Icons } from "components";
import Lottie from "lottie-web";
import NoSelection from "assets/images/illustrations/team.png";
import React from "react";
import Strings from "utils/strings";
import UserPlaceholder from "assets/images/placeholders/user2x.jpg";
// @ts-ignore
import Variables from "styles/variables.scss";
import { connect } from "react-redux";
import { replace } from "connected-react-router";

class Chat extends React.Component<any, any> {
	chatContent: any;
	ref: any;
	input: any;
	intervalId: any;
	isInitialLoad: boolean;
	isScrollingToBottom: boolean;
	searchTimer: any;

	constructor(props: any) {
		super(props);

		this.intervalId = null;
		this.isInitialLoad = false;
		this.isScrollingToBottom = false;

		this.searchTimer = null;

		this.state = {
			chats: [],
			messages: [],
			selected: null,
			showEditMessageModal: false,
			editMessage: "",
			selectedReview: null,
			showEndModal: false,
			showRatingModal: false,
			startHovered: -1,
			stars: 0,
			noReview: false,
			gettingMessages: true,
			search: "",
			chatsPage: 1,
			chatsHasMore: false,
			loadingMoreChats: false,
			messagesPage: 1,
			messagesHasMore: false,
			loadingMoreMessages: false
		};

		this.input = React.createRef();
	}

	async componentDidMount() {
		const { dispatch, location } = this.props;
		const { state } = location;
		const { startChat } = state || {};

		dispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.chat.header,
						route: "/chat"
					}
				]
			}))
		);

		if (this.chatContent) {
			setTimeout(() => {
				this.chatContent.scrollTop = this.chatContent.scrollHeight;
			}, 100);
		}

		await this.getData({});

		if (startChat) {
			dispatch(replace("/chat"));
			this.startChat();
		}

		this.intervalId = setInterval(() => {
			if (document.visibilityState === "visible" && this.state.selected && this.state.messagesPage === 1) {
				this.getMessages(this.state.selected, false, 1);
			}
		}, 5000);
	}

	componentDidUpdate(prevProps: any, prevState: any) {
		const { selected, chats } = this.state;
		const { pendingMessages, dispatch, acceptedChat, finishedChat } = this.props;

		if (
			pendingMessages.pending &&
			!prevProps.pendingMessages?.pending &&
			Boolean(selected) &&
			selected === pendingMessages?.id
		) {
			this.getMessages(pendingMessages.id, true, 1);
			dispatch(setPendingMessages({ pending: false, id: null, message: "", data: null }));
		}

		if (pendingMessages.pending && pendingMessages.id !== selected) {
			const chat = chats.find((tmp: any) => tmp._id === pendingMessages.id);

			if (chat) {
				chat.pendingMessages = true;
				chat.lastMessage = {
					message: pendingMessages.message,
					_created: DateTime.utc()
				};
			}

			this.setState({ chats });
			dispatch(setPendingMessages({ pending: false, id: null, message: "", data: null }));
		}

		if (acceptedChat?.accepted) {
			const chats = this.state.chats || [];
			const chat = chats.find((tmp: any) => tmp._id === acceptedChat?.current);

			if (chat) {
				this.getData({ selectChat: acceptedChat?.record });
			}

			dispatch(setAcceptedChat({ accepted: false, current: null, record: null }));
		}

		if (finishedChat?.finished) {
			const chats = this.state.chats || [];
			const chat = chats.find((tmp: any) => tmp._id === finishedChat?.record);

			if (chat) {
				const isPending = chat._id?.slice(-1) === "_";
				this.getData({ selectChat: isPending ? null : finishedChat?.record });
			}

			dispatch(setFinishedChat({ finished: false, record: null }));
		}
	}

	componentWillUnmount() {
		if (this.intervalId) {
			clearInterval(this.intervalId); // Clear the interval when the component is unmounted
		}

		if (this.searchTimer) {
			clearTimeout(this.searchTimer);
		}
	}

	async getData({
		newChat = false,
		selectChat,
		silent = false,
		page = 1
	}: {
		newChat?: boolean;
		selectChat?: string;
		silent?: boolean;
		page?: number;
	}) {
		const { dispatch } = this.props;

		if (!silent) {
			dispatch(setLoader(true));
		}

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriChats(),
				params: { page, limit: 20, q: this.state.search }
			});

			if (response.ok) {
				const { chats: newChats, reviews, hasMore } = response.data.results || {};

				if (page === 1) {
					if (!newChats.length) {
						this.loadAnimation();
					} else {
						Lottie.destroy();
					}

					let selected = null;
					if (newChat && newChats.length) {
						selected = newChats.find((chat: any) => !chat.psychologist)?._id;
					}

					if (selectChat && newChats.length) {
						selected = selectChat;
					}

					if (reviews?.length) {
						this.setState({ selectedReview: reviews[0], showRatingModal: true });
					}

					this.setState({ chats: newChats, selected, chatsPage: 1, chatsHasMore: hasMore || false }, () => {
						if (selectChat) {
							this.isInitialLoad = true;
							this.getMessages(selectChat, true, 1);
						}
					});
				} else {
					// Append more chats
					this.setState((prevState: any) => ({
						chats: [...prevState.chats, ...newChats],
						chatsPage: page,
						chatsHasMore: hasMore || false,
						loadingMoreChats: false
					}));
				}
			} else {
				notification.error({
					message: Strings.sidebar.chat,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
				if (page > 1) this.setState({ loadingMoreChats: false });
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
			if (page > 1) this.setState({ loadingMoreChats: false });
		}

		if (!silent) {
			dispatch(setLoader(false));
		}
	}

	async getMessages(id: string, refresh: boolean = true, page: number = 1) {
		const { chats } = this.state;
		const { dispatch } = this.props;

		const chat = chats.find((tmp: any) => tmp._id === id);
		if (chat) {
			chat.pendingMessages = false;
		}

		if (page === 1) {
			if (refresh) this.setState({ gettingMessages: true, chats });
			else this.setState({ chats });
		} else {
			this.setState({ loadingMoreMessages: true });
		}

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriChats(id),
				params: { page, limit: 30 }
			});

			if (response.ok) {
				const { messages: newMessages, hasMore } = response.data.results || {};

				if (page === 1) {
					if (chat) {
						chat.lastMessage = {
							message: newMessages[newMessages.length - 1]?.text,
							_created: newMessages[newMessages.length - 1]?.createdAt
						};
					}

					const initialLoad = this.isInitialLoad;
					this.isInitialLoad = false;

					if (this.chatContent && refresh && initialLoad) {
						this.chatContent.style.visibility = "hidden";
					}

					this.setState(
						{ messages: newMessages, messagesPage: 1, messagesHasMore: hasMore || false, chats },
						() => {
							if (this.chatContent && refresh) {
								this.isScrollingToBottom = true;
								setTimeout(() => {
									this.chatContent.style.scrollBehavior = "auto";
									this.chatContent.scrollTop = 999999;
									requestAnimationFrame(() => {
										this.chatContent.style.visibility = "visible";
										this.chatContent.style.scrollBehavior = "smooth";
										this.isScrollingToBottom = false;
									});
								}, 100);
							}
						}
					);
				} else {
					// Prepend older messages and restore scroll position
					const prevScrollHeight = this.chatContent?.scrollHeight || 0;
					const prevScrollTop = this.chatContent?.scrollTop || 0;
					this.setState(
						(prevState: any) => ({
							messages: [...newMessages, ...prevState.messages],
							messagesPage: page,
							messagesHasMore: hasMore || false,
							loadingMoreMessages: false
						}),
						() => {
							if (this.chatContent) {
								const prevScrollBehavior = this.chatContent.style.scrollBehavior;
								this.chatContent.style.scrollBehavior = "smooth";
								this.chatContent.scrollTop =
									prevScrollTop + (this.chatContent.scrollHeight - prevScrollHeight);
								this.chatContent.style.scrollBehavior = prevScrollBehavior;
							}
						}
					);
				}

				dispatch(setPendingMessages({ pending: false, id: null, message: "", data: null }));
			} else {
				notification.error({
					message: Strings.sidebar.chat,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
				if (page > 1) this.setState({ loadingMoreMessages: false });
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
			if (page > 1) this.setState({ loadingMoreMessages: false });
		}

		if (page === 1) {
			this.setState({ gettingMessages: false });
		}
	}

	async deleteMessage(id: string) {
		let response: any;

		try {
			response = await API.delete({
				url: Endpoints.uriChatMessage(this.state.selected, id)
			});

			if (response.ok) {
				this.getMessages(this.state.selected, false, 1);
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		this.setState({ gettingMessages: false });
	}

	async editMessage() {
		let response: any;
		let body = {
			message: this.state.editMessage.text
		} as any;

		try {
			response = await API.put({
				url: Endpoints.uriChatMessage(this.state.selected, this.state.editMessage._id),
				data: body
			});

			if (response.ok) {
				this.getMessages(this.state.selected, false, 1);

				this.setState({
					showEditMessageModal: false,
					editMessage: null
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		this.setState({ gettingMessages: false });
	}

	async sendMessage() {
		const { selected, inputMessage, messages } = this.state;
		const { user } = this.props;

		if (!selected || !inputMessage) return;

		// Optimistically append the message immediately
		const tempId = `temp_${Date.now()}`;
		const optimisticMessage = {
			_id: tempId,
			text: inputMessage,
			user: { _id: user._id, name: user.name, photo: user.photo },
			createdAt: new Date().toISOString(),
			read: false
		};

		this.setState({ inputMessage: "", messages: [...messages, optimisticMessage] }, () => {
			if (this.chatContent) {
				this.chatContent.style.scrollBehavior = "smooth";
				this.chatContent.scrollTop = this.chatContent.scrollHeight;
			}
			this.input?.current?.focus();
		});

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriChats(selected),
				data: {
					message: inputMessage
				}
			});

			if (response.ok) {
				await this.getMessages(selected, true, 1);
			} else {
				// Roll back optimistic message
				this.setState({ messages, inputMessage });
				notification.error({
					message: Strings.sidebar.chat,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			// Roll back optimistic message
			this.setState({ messages, inputMessage });
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async startChat(reopen: boolean = false) {
		const { chats, selected } = this.state;
		const { dispatch } = this.props;

		if (chats.some((chat: any) => !chat.finished)) {
			return notification.warn({
				message: Strings.sidebar.chat,
				description: Strings.chat.chatOpen,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(true));

		let response: any;
		try {
			let body = {} as any;
			if (reopen) {
				body.psychologist = chats.find((chat: any) => chat._id === selected)?.psychologist?._id;
			}

			response = await API.patch({
				url: Endpoints.uriChats("start"),
				data: body
			});

			if (response.ok) {
				if (reopen) {
					this.getData({ selectChat: response.data.results.chat?.socketId });
				} else {
					this.setState({ selected: null, messages: [] }, () => this.getData({ newChat: true }));
				}
			} else {
				notification.error({
					message: Strings.sidebar.chat,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async closeChat({ unselect = false }: { unselect?: boolean }) {
		const { selected } = this.state;

		if (!selected) return;

		let response: any;
		try {
			response = await API.patch({
				url: Endpoints.uriChats(`finish/${selected}`),
				data: {}
			});

			if (response.ok) {
				if (unselect) {
					this.setState({ showEndModal: false, selected: null, messages: [] });
				} else {
					this.setState({ showEndModal: false });
				}
			} else {
				notification.error({
					message: Strings.sidebar.chat,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async sendRating() {
		const { selected, selectedReview, stars } = this.state;
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.patch({
				url: Endpoints.uriChats(`review/${selectedReview ? selectedReview._id : selected}`),
				data: {
					rating: stars
				}
			});

			this.setState({ selectedReview: null });

			if (response.ok) {
				notification.success({
					message: Strings.sidebar.chat,
					description: Strings.chat.sentReview,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.sidebar.chat,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	loadAnimation() {
		Lottie.loadAnimation({
			container: this.ref,
			renderer: "svg",
			loop: true,
			autoplay: true,
			animationData: Animation
		});
	}

	renderEndChatModal() {
		const { showEndModal } = this.state;
		const { mobile } = this.props;

		return (
			<Modal
				centered={true}
				closable={true}
				onCancel={() => this.setState({ showEndModal: false })}
				visible={showEndModal}
				footer={null}
				width={mobile ? "100%" : 400}
			>
				<div className="EndChatModal">
					<h2>{Strings.chat.endChat}</h2>
					<div className="EndChatOptions">
						<button onClick={() => this.setState({ showEndModal: false })}>{Strings.generic.no}</button>
						<button
							onClick={() => {
								this.setState({ showEndModal: false, showRatingModal: true });
							}}
							className="--btn-primary"
						>
							{Strings.generic.yes}
						</button>
					</div>
				</div>
			</Modal>
		);
	}

	renderRatingModal() {
		const { chats, showRatingModal, selected, selectedReview, startHovered, stars } = this.state;
		const { mobile } = this.props;

		let chat = null;

		if (selectedReview) {
			chat = selectedReview;
		} else if (chats.length && selected) {
			chat = chats.find((chat: any) => chat._id === selected);
		}

		return (
			<Modal
				centered={true}
				closable={true}
				onCancel={async () => {
					this.setState({ stars: 0 });
					if (selectedReview) {
						await this.sendRating();
					} else await Promise.all([this.sendRating(), this.closeChat({})]);

					this.setState({ showRatingModal: false });
				}}
				visible={showRatingModal}
				footer={null}
				width={mobile ? "100%" : 400}
			>
				<div className="RatingChatModal">
					<h2>{Strings.chat.howDidItGo}</h2>
					<div className="RatingPsychologist">
						<img src={chat?.psychologist?.photo || UserPlaceholder} alt="psychologist avatar" />
						<h2>{chat?.psychologist?.name}</h2>
					</div>
					<div className="RatingStars">
						{Array(5)
							.fill("")
							.map((_: any, index: number) => {
								let className = "";
								if (index <= startHovered) {
									className = "-btn--hovered";
								} else if (index + 1 <= stars) {
									className = "-btn--selected";
								}

								return (
									<button
										key={`star_${index}`}
										className={className}
										onMouseEnter={() => this.setState({ startHovered: index })}
										onMouseLeave={() => this.setState({ startHovered: -1 })}
										onClick={() => this.setState({ stars: index + 1 })}
									>
										<Icons.Star />
									</button>
								);
							})}
					</div>
					<button
						onClick={async () => {
							if (stars) {
								if (selectedReview) {
									await this.sendRating();
								} else await Promise.all([this.sendRating(), this.closeChat({})]);

								this.setState({ showRatingModal: false, stars: null });
							} else {
								notification.warn({
									message: Strings.sidebar.chat,
									description: Strings.chat.selectRating,
									placement: "bottomRight",
									duration: 5
								});
							}
						}}
						className="RatingRate"
					>
						{Strings.generic.confirm}
					</button>
				</div>
			</Modal>
		);
	}

	renderEditMessageModal() {
		const { showEditMessageModal } = this.state;
		const { mobile } = this.props;

		return (
			<Modal
				centered={true}
				closable={true}
				onCancel={() => this.setState({ showEditMessageModal: false })}
				visible={showEditMessageModal}
				footer={null}
				width={mobile ? "100%" : 400}
			>
				<div className="EndChatModal">
					<h2>{Strings.fields.edit}</h2>
					<div>
						<Input
							value={this.state.editMessage?.text || ""}
							onChange={(e) =>
								this.setState({
									editMessage: {
										...this.state.editMessage,
										text: e.target.value
									}
								})
							}
						/>
					</div>
					<div className="EndChatOptions">
						<button onClick={() => this.setState({ showEditMessageModal: false })}>
							{Strings.appointments.cancel}
						</button>
						<button
							onClick={() => {
								this.editMessage();
							}}
							className="--btn-primary"
						>
							{Strings.generic.confirm}
						</button>
					</div>
				</div>
			</Modal>
		);
	}

	handleChatListScroll = (e: React.UIEvent<HTMLDivElement>) => {
		const { loadingMoreChats, chatsHasMore, chatsPage } = this.state;
		const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

		if (scrollHeight - scrollTop - clientHeight < 60 && chatsHasMore && !loadingMoreChats) {
			this.setState({ loadingMoreChats: true });
			this.getData({ page: chatsPage + 1, silent: true });
		}
	};

	handleMessagesScroll = (e: React.UIEvent<HTMLDivElement>) => {
		const { loadingMoreMessages, messagesHasMore, messagesPage, selected } = this.state;
		const { scrollTop } = e.currentTarget;

		if (scrollTop < 60 && messagesHasMore && !loadingMoreMessages && selected && !this.isScrollingToBottom) {
			this.getMessages(selected, false, messagesPage + 1);
		}
	};

	getFilteredChats = (chats: any) => {
		const normalizeString = (str: string) => {
			return str
				.normalize("NFD") // Normalize to NFD (Normalization Form Decomposition)
				.replace(/[\u0300-\u036f]/g, "") // Remove diacritics
				.toLowerCase(); // Convert to lower case
		};

		return chats.filter((chat: any) => {
			const userName = chat.psychologist?.name || "";
			const userExternalName = chat.psychologist?.externalName || "";
			const normalizedUserName = normalizeString(userName);
			const normalizedUserExternalName = normalizeString(userExternalName);
			const normalizedSearch = normalizeString(this.state.search);

			return (
				normalizedUserName.includes(normalizedSearch) || normalizedUserExternalName.includes(normalizedSearch)
			);
		});
	};

	isBetweenOpeningHours = () => {
		const lisbonTime = new Date().toLocaleString("en-US", { timeZone: "Europe/Lisbon" });
		const lisbonDate = new Date(lisbonTime);
		const hour = lisbonDate.getHours();

		return hour >= 9 && hour < 24;
	};

	render() {
		const { chats, selected, inputMessage, messages, gettingMessages, loadingMoreChats, loadingMoreMessages } =
			this.state;
		const { user, mobile } = this.props;

		let chat = null as any;
		if (chats.length && selected) {
			chat = chats.find((chat: any) => chat._id === selected);
		}

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.chat} | Team24</title>
					<meta name="description" content="Description of Chat" />
				</Helmet>
				<div className="ChatContent">
					<h1 className="GenericTitle">{Strings.sidebar.chat}</h1>
					{chats?.length > 0 ? (
						<div className="ChatBoxWrapper">
							<div className="ChatUserListContainer">
								<div className="ChatUserListHeader">
									<Input.Search
										value={this.state.search || ""}
										placeholder={Strings.generic.search}
										onChange={(e: any) => {
											const val = e.target.value;
											this.setState({ search: val });
											if (this.searchTimer) clearTimeout(this.searchTimer);
											this.searchTimer = setTimeout(() => this.getData({ page: 1, silent: true }), 300);
										}}
									/>
								</div>
								<div className="ChatUserList" onScroll={this.handleChatListScroll}>
									{chats.map((chat: any, index: number) => (
										<div
											key={`psychologist_${chat._id}`}
											className={`ChatUser${selected === chat._id ? " --chat-selected" : ""}`}
											onClick={() => {
												if (selected !== chat._id) {
													this.setState(
														{
															selected: chat._id,
															messages: [],
															messagesPage: 1,
															messagesHasMore: false
														},
														() => {
															this.isInitialLoad = true;
															this.getMessages(chat._id, true, 1);
														}
													);
												}
											}}
										>
											<img
												src={chat.psychologist?.photo || DoctorPlaceholder}
												alt="psychologist avatar"
											/>
											<div className="ChatUserDetails">
												<div className="ChatUserRow">
													<p>
														{chat.psychologist?.externalName ||
															chat.psychologist?.name ||
															"Chat Pendente"}
													</p>
													{Boolean(chat?.lastMessage?._created) ? (
														<p className="ChatMessageTime">
															{DateTime.fromISO(chat.lastMessage?._created).toFormat(
																"HH:mm"
															)}
														</p>
													) : (
														<p className="ChatMessageTime">
															{DateTime.fromISO(chat.startDate).toFormat("HH:mm")}
														</p>
													)}
												</div>
												<div className="ChatUserRow">
													{Boolean(chat?.lastMessage?.message) ? (
														<p
															className={`ChatMessage${
																chat?.pendingMessages ? " --bold" : ""
															}`}
														>
															{chat?.lastMessage?.message}
														</p>
													) : (
														<span>&nbsp;</span>
													)}
													{chat.finished && (
														<div className="ChatClosedBadge">{Strings.fields.closed}</div>
													)}
												</div>
											</div>
										</div>
									))}
									{loadingMoreChats && (
										<div className="ChatLoadingMore">
											<span>{Strings.generic.loading || ""}</span>
										</div>
									)}
								</div>
								<div className="ChatUserListAdd">
									<button onClick={() => this.startChat()}>
										<Icons.ChatFilled />
										<p>{Strings.chat.startChat}</p>
									</button>
								</div>
							</div>
							<div className="ChatConversationContainer">
								{!Boolean(chat?.finished) && selected && !this.isBetweenOpeningHours() && (
									<div className="ChatOpeningHoursOuterBlock">
										<div className="ChatOpeningHoursInnerBlock">
											<p>{Strings.chat.outOfOpeningHours}</p>
										</div>
									</div>
								)}
								{(selected && (
									<div className="ChatSelectedUser">
										<div className="ChatSelectedUserDetail">
											<img
												src={chat?.psychologist?.photo || DoctorPlaceholder}
												alt="psychologist avatar"
											/>
											<p>{chat?.psychologist?.name || "Pending"}</p>
										</div>
										<button
											disabled={chat?.finished}
											onClick={() => {
												if (chat?.psychologist) {
													this.setState({ showEndModal: true });
												} else {
													this.closeChat({ unselect: true });
												}
											}}
										>
											<em className="moon-close" />
										</button>
									</div>
								)) ||
									null}
								<div
									id="chatContent"
									ref={(ref) => (this.chatContent = ref)}
									className={`ChatMessagesContainer${selected ? "" : " --no-header"}`}
									onScroll={this.handleMessagesScroll}
								>
									{loadingMoreMessages && (
										<div className="ChatLoadingMoreMessages">
											<span>{Strings.generic.loading || ""}</span>
										</div>
									)}
									{messages?.map((message: any, index: number) => {
										const rightSide = message.user?._id === user._id;
										let lastMessageSameUser = false;
										let dayChanged = false;

										if (index > 0) {
											lastMessageSameUser =
												messages[index - 1].user?._id === message.user?._id &&
												DateTime.fromISO(messages[index - 1].createdAt).toFormat("HH:mm") ===
													DateTime.fromISO(message.createdAt).toFormat("HH:mm");

											if (
												DateTime.fromISO(message.createdAt) >
													DateTime.fromISO(messages[index - 1].createdAt) &&
												DateTime.fromISO(message.createdAt).day !==
													DateTime.fromISO(messages[index - 1].createdAt).day
											) {
												dayChanged = true;
											}
										}

										return (
											<React.Fragment key={`chat_message_${index}`}>
												{(dayChanged || index === 0) && (
													<div className="ChatMessageNewDay">
														{DateTime.fromISO(message.createdAt).toFormat("dd/MM/yyyy")}
													</div>
												)}
												<Row>
													{rightSide && (
														<Col xs={{ span: 16, offset: 8 }}>
															<div className="ChatAlignRight">
																{!lastMessageSameUser && (
																	<div className="ChatUserBlock --chat-align-right">
																		<div className="ChatUserAvatar">
																			<img
																				src={
																					message.user?.avatar ||
																					UserPlaceholder
																				}
																				alt="user avatar"
																			/>
																		</div>
																		<div className="ChatUserDetails">
																			<p>{message.user?.name}</p>
																			<small>
																				{DateTime.fromISO(
																					message.createdAt
																				).toFormat("HH:mm")}
																			</small>
																		</div>
																	</div>
																)}
																<div
																	className={`ChatEntry ${
																		rightSide ? "--chat-me" : ""
																	} ${chat?.finished ? "--finished" : ""}`}
																>
																	<span className={"message"}>{message.text}</span>
																	<div className="ChatEntryFooter">
																		<span
																			className={`checkdouble-icon ${
																				message.read
																					? "--message-read"
																					: "--message-unread"
																			}`}
																		>
																			<Icons.CheckDouble />
																		</span>
																		{!chat?.finished && (
																			<>
																				<span
																					className="pencil-icon"
																					onClick={() => {
																						this.setState({
																							showEditMessageModal: true,
																							editMessage: message
																						});
																					}}
																				>
																					<Icons.Pencil color={"#ffffff"} />
																				</span>
																				<Popconfirm
																					placement="topRight"
																					title={
																						Strings.chat
																							.confirmDeleteMessage
																					}
																					onConfirm={() => {
																						this.deleteMessage(message._id);
																					}}
																					okText={Strings.generic.yes}
																					cancelText={Strings.generic.no}
																				>
																					<span className="bin-icon">
																						<Icons.Bin color={"white"} />
																					</span>
																				</Popconfirm>
																			</>
																		)}
																	</div>
																</div>
															</div>
														</Col>
													)}
													{!rightSide && (
														<Col xs={16}>
															<div>
																{!lastMessageSameUser && (
																	<div className="ChatUserBlock">
																		<div className="ChatUserAvatar">
																			<img
																				src={
																					message.user?.avatar ||
																					DoctorPlaceholder
																				}
																				alt="user avatar"
																			/>
																		</div>
																		<div className="ChatUserDetails">
																			<p>
																				{message.user?.externalName ||
																					message.user?.name}
																			</p>
																			<small>
																				{DateTime.fromISO(
																					message.createdAt
																				).toFormat("HH:mm")}
																			</small>
																		</div>
																	</div>
																)}
																<span className="ChatEntry">{message.text}</span>
															</div>
														</Col>
													)}
												</Row>
											</React.Fragment>
										);
									})}
									{Boolean(chat?.finished) && !gettingMessages && (
										<div className="ChatClosedOuterBlock">
											<div className="ChatClosedInnerBlock">
												<p>
													{Strings.chat.closedChatFormat1}{" "}
													<span onClick={() => this.startChat(true)}>
														{Strings.chat.here}
													</span>{" "}
													{Strings.chat.closedChatFormat2}
												</p>
											</div>
										</div>
									)}
									{(!selected && (
										<div className="ChatNoSelection">
											<div className="ChatNoSelectionIllustration">
												<img src={NoSelection} alt="chat illustration" />
											</div>
											<p>{Strings.chat.selectChat}</p>
										</div>
									)) ||
										null}
								</div>
								{(selected && (
									<div className="ChatSendMessageContainer">
										<textarea
											rows={2}
											value={inputMessage || ""}
											onChange={(e: any) => this.setState({ inputMessage: e.target.value })}
											placeholder={Strings.appointments.replyMessage}
											disabled={chat?.finished}
											onKeyPress={(e: any) => {
												if (e.key === "Enter" && !e.shiftKey) {
													e.preventDefault();

													if (inputMessage?.trim()) {
														this.sendMessage();
													}

													return;
												}
											}}
										/>
										<button
											className="ChatSendButton"
											onClick={() => {
												if (inputMessage?.trim()) {
													this.sendMessage();
												}
											}}
											disabled={chat?.finished}
										>
											<Icons.Send disabled={!inputMessage} />
										</button>
									</div>
								)) ||
									null}
							</div>
						</div>
					) : (
						<div className="EmptyChats">
							<div
								ref={(ref: any) => {
									this.ref = ref;
								}}
							/>
							<p>{Strings.chat.noChats}</p>
							<div className="EmptyChatsButton">
								<button onClick={() => this.startChat()}>
									<Icons.ChatFilled />
									<p>{Strings.chat.startChat}</p>
								</button>
							</div>
						</div>
					)}
				</div>
				{mobile && <Footer />}
				{this.renderEndChatModal()}
				{this.renderRatingModal()}
				{this.renderEditMessageModal()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	user: state.user,
	mobile: state.mobile,
	pendingMessages: state.pendingMessages,
	acceptedChat: state.acceptedChat,
	finishedChat: state.finishedChat
});

export default connect(mapStateToProps)(Chat);
